var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUiCheckLtr = function SvgUiCheckLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M94.1 13.919a3.16 3.16 0 0 1 4.487.033 3.206 3.206 0 0 1 .04 4.44l-.073.074-68.193 67.616a3.16 3.16 0 0 1-4.397.055l-.073-.072L.429 60.446a3.206 3.206 0 0 1 0-4.514 3.16 3.16 0 0 1 4.413-.072l.074.072L28.15 79.309z",
    clipRule: "evenodd"
  })));
};
export default SvgUiCheckLtr;